export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Extrabold-c9d202c8ffb95b6ec8c1f881e3c25a05.otf";